import { useEffect, useState } from "react";
import customTableStyles from "./customTable.styles";
import {
  Box,
  Checkbox,
  FormControl,
  Grid,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import NoData from "../../../assets/images/NoDataTableImage.svg";
import Pagination from "@mui/material/Pagination";
import usePagination from "./Pagination";
import paginationStyles from "./Pagination.styles";
import React from "react";
interface CustomProps {
  headers: any[];
  rows: any[];
  customClasses?: { headerCellClass?: string; rowClass?: string };
  size?: any;
  searchFields?: string[];
  handleRowClick?: Function;
  handlePageChange?: Function;
  handleRowsPerPage?: Function;
  paginationCount?: number;
  rowsPerPage?: number;
  pageNumber?: number;
  currentSelectedTab?: string;
  checkboxSelection?: boolean;
  handleClick?: any;
  onSelectAllClick?: any;
  isSelected?: any;
  isSelectAll?: any;
  isLoading?: boolean;
  searchParam?: string;
  type?:string
}

const CustomTable = (props: CustomProps) => {
  const classes = customTableStyles;
  const pagination = paginationStyles;
  const [page, setPage] = useState<number>(1);
  const [rowData, setRowData] = useState(props.rows);
   const [paginationModel, setPaginationModel] = React.useState({
      pageSize: 25,
      page: 0,
    });
      const [metaData, setMetaData] = useState<any>({});
  const [selected, setSelected] = useState<any>();
  useEffect(() => {
    setSelected(props?.rows?.map((item: any) => item?.id));
    setRowData(props?.rows);
  }, [props.rows]);
  useEffect(() => {
    if (props.searchParam === "") {
      setPage(1);
    } else if (props.currentSelectedTab) {
      setPage(1);
    }
  }, [props.searchParam, props.currentSelectedTab]);

  const handlePageSizeChange = (event: any) => {
    setPaginationModel({
      ...paginationModel,
      pageSize: event.target.value,
      page: 0,
    });
  };

  const getRowOnClickHandler = (row: any) => {
    let handleRowClick = props.handleRowClick
      ? {
          onClick: () => props.handleRowClick && props.handleRowClick(row),
        }
      : {};
    return handleRowClick;
  };

  const PER_PAGE = props.rowsPerPage ?? 10;
  const dataCount = Math.ceil(props.paginationCount! / PER_PAGE);
  const finalTableData = usePagination(rowData, PER_PAGE);

  const getRowData = (row: any) => {
    return props?.headers?.map((column, index) => (
      <>
        <TableCell sx={classes.tableCell} align={column["align"]} key={index}>
          {row[column["field"]] ?? "-"}
        </TableCell>
      </>
    ));
  };

  const getHeaders = () => {
    let checkValue: boolean | null = null;
    if (props?.isSelectAll?.length)
      checkValue = selected?.every((item: any) =>
        props.isSelectAll?.includes(item)
      );
    return (
      <TableHead>
        <TableRow>
          {props.checkboxSelection && (
            <TableCell padding="checkbox" sx={classes.headerCheckbox}>
              <Checkbox
                sx={classes.checkbox}
                checked={checkValue ?? false}
                onChange={props.onSelectAllClick}
                inputProps={{
                  "aria-label": "select all desserts",
                }}
              />
            </TableCell>
          )}
          {props.headers.map((column, index) => (
            <TableCell
              sx={classes.tableHeaderCell}
              align={column["align"]}
              key={index}
            >
              {column.name}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };

  const getRows = () => {
    return (
    

      <TableBody sx={classes.tableBody}>
        {finalTableData.currentData()?.map((row: any, index: any) => {
          return (
            <>
              <TableRow
                sx={classes.tableRow}
                key={index}
                {...getRowOnClickHandler(row)}
              >
                {props.checkboxSelection && (
                  <TableCell padding="checkbox">
                    <Checkbox
                      onClick={(event:any) =>
                        props.handleClick ? props.handleClick(event, row) : null
                      }
                      color="primary"
                      checked={
                        props.isSelected ? props.isSelected(row.id) : null
                      }
                      inputProps={{
                        "aria-labelledby": `enhanced-table-checkbox-${index}`,
                      }}
                    />
                  </TableCell>
                )}
                      {/* <Box sx={{ maxHeight: "500px", overflow: "auto" }}> */}
                {getRowData(row)}
        {/* </Box> */}
              </TableRow>
            </>
          );
        })}
      </TableBody>
     
    );
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    props.handlePageChange && props.handlePageChange(event, newPage - 1);
    setPage(newPage);
  };

  const getTablePagination = () => {
    return (
      // <>
      //   <Pagination
      //     page={page}
      //     count={dataCount}
      //     shape="rounded"
      //     size="medium"
      //     sx={pagination.pageBtn}
      //     onChange={(event: any, page: any) => {
      //       handleChangePage(event, page);
      //     }}
      //     showLastButton
      //     showFirstButton
      //   />
      // </>

      <Box sx={classes.footer}>
      <Box sx={classes.footerRight}>
        <div style={{ marginRight: '8px' }}>Rows per page</div>

        <FormControl size="small" sx={{ border: 'none' }}>
          <Select
            value={paginationModel.pageSize}
            onChange={handlePageSizeChange}
            label="Page Size"
            sx={{
              fontSize: '11px',
              border: 'none',
              minWidth: '60px',
            }}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
            <MenuItem value={200}>200</MenuItem>

          </Select>
        </FormControl>

        <Pagination
          count={Math.ceil(metaData?.total / paginationModel.pageSize)}
          page={paginationModel.page + 1}
          onChange={(event, value) => {
            setPaginationModel({
              ...paginationModel,
              page: value - 1,
            });
          }}
          size="small"
          siblingCount={1}
          boundaryCount={1}
          sx={classes.font}
        />

      </Box>

    </Box>
    );
  };
  const getTable = () => {
    return (
  
            <Paper sx={{ width: '100%', overflow: 'hidden' ,boxShadow:"none" }}>
      <TableContainer sx={{
  height:
    props.type === "myAttendance"
      ? "calc(100vh - 414px)"
      : props.type === "department"
      ? "calc(100vh - 284px)"
      : props.type === "role" 
      ? "calc(100vh - 241px)"
      : "calc(100vh - 241px)",
}}>

        <Table sx={classes.table} stickyHeader >
          {getHeaders()}
    
          {!props.isLoading && rowData?.length <= 0 ? (
            <TableCell
              colSpan={7}
              style={{
                padding: "20px",
              }}
            >
              <Box textAlign="center">
                <Box
                  component="img"
                  src={NoData}
                  overflow="auto"
                  height="100px"
                  width="100%"
                />
                <Typography sx={classes.mediumFonts}>
                  No Data Available!
                </Typography>
              </Box>
            </TableCell>
          ) : (
            // <Box sx={{ maxHeight: "500px", overflow: "auto" }}>
            getRows()
            // </Box>
          )}

      
        </Table>
        </TableContainer>
        {rowData?.length ? getTablePagination() : null}
        </Paper>
      // </Box>
    );
  };
  return getTable();
};

export default CustomTable;
